import React, { useContext, useEffect, useReducer, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import FormControl from 'react-bootstrap/FormControl';
import Row from 'react-bootstrap/Row';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Store } from '../Store';
import MessageBox from '../components/MessageBox';
import SearchProduct from '../components/SearchProduct';
import useAxios from '../hooks/useAxios';
import { getError, getUnitLabel } from '../utils';

const reducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE_REQUEST':
      return { ...state, loadingUpdate: true };
    case 'UPDATE_SUCCESS':
      return { ...state, loadingUpdate: false };
    case 'UPDATE_FAIL':
      return { ...state, loadingUpdate: false };
    default:
      return state;
  }
};

export default function ProductStockOutputScreen() {
  const axios = useAxios();
  const { state } = useContext(Store);
  const { userInfo } = state;
  const [product, setProduct] = useState({});
  const [stockOutputs, setStockOutputs] = useState([]);
  const [selectedFeature, setSelectedFeature] = useState();

  const params = useParams(); // /product/:id
  const { id: productId } = params;

  const [{ error }, dispatch] = useReducer(reducer, {
    loadingUpdate: false,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data: productData } = await axios.get(
          `/api/products/${productId}`
        );
        setProduct(productData);
      } catch (err) {
        toast.error(getError(err));
      }
    };

    fetchData();
    setStockOutputs([]);
  }, [userInfo, productId]);

  const stockOutputAddHandler = (p, feature) => {
    if (product.features && product.features.length > 0 && !selectedFeature) {
      toast.error('Lutfen urun cesidi seciniz');
      return;
    }

    const filteredProducts = stockOutputs.filter((s) => {
      if (feature) {
        return s.product._id === p._id && feature === s.feature;
      } else {
        return s.product._id === p._id;
      }
    });
    if (filteredProducts && filteredProducts.length > 0) {
      toast.error(p.name + ' zaten eklenmis');
      return;
    }

    setStockOutputs([
      ...stockOutputs,
      {
        product: p,
        unit: p.unit,
        name: p.name,
        amount: 0,
        feature,
        forFeature: selectedFeature,
      },
    ]);
  };

  const amountChangeHandler = (e, stockOutput) => {
    const outs = stockOutputs.map((s) => {
      if (s.product === stockOutput.product) {
        return { ...s, amount: Number(e.target.value) };
      } else {
        return s;
      }
    });
    setStockOutputs([...outs]);
  };

  const stockOutputDeleteHandler = (stockOutput) => {
    if (stockOutput.feature) {
      const outs = stockOutputs.filter((s) => {
        if (
          s.product === stockOutput.product &&
          s.feature === stockOutput.feature
        ) {
          return false;
        } else {
          return true;
        }
      });
      productStockUpdateHandler(outs, false);
    } else {
      const outs = stockOutputs.filter(
        (s) => s.product !== stockOutput.product
      );
      productStockUpdateHandler(outs, false);
    }
  };

  const productStockUpdateHandler = async (stockOutputs, checkZero) => {
    if (checkZero) {
      const stockZeroDef = stockOutputs.filter((s) => !s.amount);

      if (stockZeroDef && stockZeroDef.length > 0) {
        toast.error('Lutfen miktar alanini sifirdan farkli bir deger giriniz');
        return;
      }
    }

    try {
      dispatch({ type: 'UPDATE_REQUEST' });
      const updatedStockOutputs = stockOutputs.map((s) => {
        return {
          product: s.product._id,
          unit: s.unit,
          amount: s.amount,
          feature: s.feature,
          forFeature: s.forFeature,
        };
      });

      await axios.put(`/api/products/stockOutputs/${productId}`, {
        stockOutputs: updatedStockOutputs,
      });

      setStockOutputs([...stockOutputs]);
      dispatch({ type: 'UPDATE_SUCCESS' });
      toast.success('Stok çıkış bilgileri güncellendi');
    } catch (error) {
      dispatch({ type: 'UPDATE_FAIL' });
      toast.error(getError(error));
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get(
          `/api/products/stockOutputs/${productId}`
        );
        setStockOutputs(data);
      } catch (err) {
        toast.error(getError(err));
      }
    };
    fetchData();
  }, [productId, userInfo]);

  return (
    <div>
      {error ? (
        <MessageBox variant="danger">{error}</MessageBox>
      ) : (
        <>
          <div>
            <Helmet>
              <title>Stok cıkısı</title>
            </Helmet>
            <h1>
              <Row>
                <Col md={4}>
                  <span className="text-danger">
                    {selectedFeature
                      ? selectedFeature + ' ' + product.name
                      : product.name}
                  </span>{' '}
                  için stok çıkışı
                </Col>
                <Col md={8}>
                  {product.features &&
                    product.features.length > 0 &&
                    product.features.map((f) => (
                      <>
                        <Button
                          key={f.name}
                          onClick={() => setSelectedFeature(f.name)}
                          variant={
                            selectedFeature === f.name ? 'danger' : 'primary'
                          }
                        >
                          {f.name}
                        </Button>
                        &nbsp;
                      </>
                    ))}
                </Col>
              </Row>
            </h1>
          </div>
          <Row>
            <Col md={3}>
              <SearchProduct
                query={product.name}
                userInfo={userInfo}
                addHandler={stockOutputAddHandler}
                type={'stock'}
                showFeatures
              ></SearchProduct>
            </Col>
            <Col md={2}></Col>
            <Col md={7}>
              <table className="table">
                <thead>
                  <tr>
                    <th>AD</th>
                    <th>MIKTAR</th>
                    <th>BIRIM</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {stockOutputs.map((s) =>
                    s.forFeature && s.forFeature !== selectedFeature ? null : (
                      <tr key={s.product._id + '' + s.feature ? s.feature : ''}>
                        <td>
                          {s.feature
                            ? s.feature + ' ' + s.product.name
                            : s.product.name}
                        </td>
                        <td>
                          <Row>
                            <Col md={6}>
                              <FormControl
                                value={s.amount}
                                onChange={(e) => amountChangeHandler(e, s)}
                              ></FormControl>
                            </Col>
                          </Row>
                        </td>
                        <td>{getUnitLabel(s.unit)}</td>
                        <td>
                          <Button
                            variant="light"
                            onClick={() => stockOutputDeleteHandler(s)}
                          >
                            <i className="fas fa-trash"></i>
                          </Button>
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
                <tfoot>
                  <tr>
                    {stockOutputs.length > 0 && (
                      <td>
                        <Button
                          variant="primary"
                          onClick={() =>
                            productStockUpdateHandler(stockOutputs, true)
                          }
                        >
                          Kaydet
                        </Button>
                      </td>
                    )}
                  </tr>
                </tfoot>
              </table>
            </Col>
          </Row>
        </>
      )}
    </div>
  );
}
